import { useState } from "react";
import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";

const BaseURL: AxiosInstance = axios.create({
  // baseURL: "http://localhost:8080/zenith-portal/public/api",
  baseURL: "https://api.zenithsms.v2nportal.com/api",
  validateStatus: (status: number): boolean => {
    return status >= 200 && status < 500;
  },
});

interface UseApiHookOptions {
  method?: "get" | "post" | "put" | "delete" | "patch";
}

const useApiHook = <T,>(url: string, options: UseApiHookOptions = {}) => {
  const [data, setData] = useState<T | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fullUrl = `${BaseURL.defaults.baseURL}${url}`;

  const getAuthToken = (): string | null => {
    return localStorage.getItem("token");
  };

  const prepareHeaders = () => {
    const token = getAuthToken();

    const headers: Record<string, string> = {};

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return headers;
  };

  const makeRequest = (payload?: any) => {
    setIsLoading(true);
    const headers = prepareHeaders();
    const method = options.method || "post";

    const requestConfig = {
      method,
      url: fullUrl,
      headers,
      ...(payload && method === "post" ? { data: payload } : {}),
      ...(payload && method === "get" ? { params: payload } : {}),
    };

    return axios(requestConfig)
      .then((response: AxiosResponse) => {
        setData(response?.data);
        setIsLoading(false);
        return response;
      })
      .catch((error: AxiosError) => {
        setIsLoading(false);

        if (error.response?.status === 401) {
          window.location.href = "/";
        }

        return error.response;
      });
  };

  return { data, isLoading, makeRequest };
};

export default useApiHook;
